import { LogOut, User as UserIcon } from 'lucide-react';
import React from 'react';

interface Props {
  firstName?: string;
  lastName?: string;
  role?: string;
  isCollapsed: boolean;
  onLogout: () => void;
}

export const SidebarUserProfile: React.FC<Props> = ({
  firstName,
  lastName,
  role,
  isCollapsed,
  onLogout,
}) => {
  const displayName = firstName
    ? `${firstName} ${lastName || ''}`.trim()
    : 'User';

  return (
    <div className="border-t border-gray-100 p-3">
      <div
        className={`flex items-center rounded-xl bg-gray-50 p-3 ${
          isCollapsed ? 'justify-center' : 'gap-3'
        }`}
      >
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-pos-primary text-white">
          <UserIcon size={20} />
        </div>

        {!isCollapsed && (
          <>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-gray-900">
                {displayName}
              </p>
              <p className="truncate text-xs capitalize text-gray-500">
                {role?.replace(/_/g, ' ') || ''}
              </p>
            </div>
            <button
              type="button"
              onClick={onLogout}
              className="p-1 text-gray-400 transition-colors hover:text-red-500"
              title="Sign out"
            >
              <LogOut size={18} />
            </button>
          </>
        )}
      </div>

      {isCollapsed && (
        <button
          type="button"
          onClick={onLogout}
          className="mt-2 flex w-full items-center justify-center rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-red-500"
          title="Sign out"
        >
          <LogOut size={18} />
        </button>
      )}
    </div>
  );
};
